import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { HardshipRequiredDocsCardState } from '../helpers/hardship.models';
import { QualifyingDocumentViewModel } from '../helpers/hardship.utils';
import { TranslateModule } from '@ngx-translate/core';

interface HardshipRequiredCardConfig {
  backgroundColor: string;
  iconName: string;
  iconColor: string;
}

@Component({
    selector: 'bw-hardship-required-docs-card',
    imports: [CommonModule, BrightsideUiModule, TranslateModule],
    templateUrl: './hardship-required-docs-card.component.html',
    styleUrl: './hardship-required-docs-card.component.css'
})
export class HardshipRequiredDocsCardComponent {
  @Input() cardInfo: QualifyingDocumentViewModel;

  cardConfig: Record<HardshipRequiredDocsCardState, HardshipRequiredCardConfig> = {
    [HardshipRequiredDocsCardState.ADD]: {
      iconColor: '#005fff',
      iconName: 'add',
      backgroundColor: 'var(--bg-blue)'
    },
    [HardshipRequiredDocsCardState.UPLOADING]: {
      iconColor: '',
      iconName: 'spinner',
      backgroundColor: 'var(--bg-blue)'
    },
    [HardshipRequiredDocsCardState.UPLOADED]: {
      iconColor: '#118721',
      iconName: 'trash',
      backgroundColor: 'var(--green-5)'
    },
    [HardshipRequiredDocsCardState.ERROR]: {
      iconColor: '#d63b39',
      iconName: 'refresh',
      backgroundColor: 'var(--red-5)'
    },
    [HardshipRequiredDocsCardState.PENDING]: {
      iconColor: '#005fff',
      iconName: 'spinner',
      backgroundColor: 'var(--bg-blue)'
    },
    [HardshipRequiredDocsCardState.SUBMITTED]: {
      iconColor: '#118721',
      iconName: 'checkmark',
      backgroundColor: 'var(--green-5)'
    },
  }

  // handleClickEvent() {
  //   this.cardClicked.emit({...this.cardInfo, state: this.state})
  // }
}
